// @flow
import CreateServiceNoShowModalContainer from './CreateServiceNoShowModalContainer';

export default CreateServiceNoShowModalContainer;
